import React, { Component } from 'react';
import classNames from 'classnames';
import { Drawer, Layout } from '@nackle/origami';
import { EVENT_ENVIRONMENT } from '../config';

import Deck, { Footer, LeftNav } from '..';


export default class MainWrapper extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            sidebarOpen: false
        };
        this.sidebarRef = React.createRef();
    }

    componentDidMount() {

        window.addEventListener( 'touchstart', this.handleTouchOrClick );
        window.addEventListener( 'mousedown', this.handleTouchOrClick );
    }

    componentWillUnmount() {
        window.removeEventListener( 'touchstart', this.handleTouchOrClick );
        window.removeEventListener( 'mousedown', this.handleTouchOrClick );
    }


    toggleSidebar = () => {
        const { sidebarOpen } = this.state;
        this.setState( { sidebarOpen: !sidebarOpen } );
        if ( sidebarOpen === false ) {
            //when drawer is open, lock body so can't scroll
            document.body.style.overflow = 'hidden';
        } else if ( sidebarOpen === true ) {
            //allow scroll again when drawer is closed
            document.body.style.overflow = null;
        }
    };
    handleTouchOrClick = ( e ) => {
        if ( this.sidebarRef && this.sidebarRef.current && !this.sidebarRef.current.contains( e.target ) && !document.querySelector( '.menu-button' ).contains( e.target ) ) {
            this.setState( { sidebarOpen: false } );
            document.body.style.overflow = null;
        }
    };


    render() {
        const {
            header,
            footer,
            leftNav,
            auth,
            user,
            locale,
            tokens,
            headerClassName,
            footerClassName,
            isUmbrella,
            guest,
            isDM,
            contentLoaded,
            currentCompany,
            loaded,
            navigationData,
            notifications,
            children,
            userNavData,
            idUrl
        } = this.props;

        const {
            sidebarOpen
        } = this.state;
        const classes = classNames(
            'nkl-deck-app-root',
            `env-${ EVENT_ENVIRONMENT }`,
            {
                'nkl-deck-no-header': header === false,
                'nkl-deck-no-footer': footer === false,
                'nkl-deck-no-leftNav': leftNav === false
            }
        );
        const sidebarClasses = classNames( {
            'open': sidebarOpen,
            'collapsed': !sidebarOpen
        } );

        return (
            <Layout className={ classes }>
                { header !== false &&
                    <Deck
                        hide={ guest }
                        auth={ auth }
                        user={ user }
                        locale={ locale }
                        tokens={ tokens }
                        currentCompany={ currentCompany }
                        contentLoaded={ contentLoaded }
                        loaded={ loaded }
                        piersUser={ this.props.piersUser }
                        className={ headerClassName }
                        notifications={ notifications }
                        fetchNotifications={ this.fetchNotifications }
                        isUmbrella={ isUmbrella }
                        isDM={ isDM }
                        leftNav={ leftNav }
                        toggleSidebar={ this.toggleSidebar }
                        sidebarOpen={ sidebarOpen }
                        userNavData={ userNavData }
                        />
                    }
                <div className="nkl-deck-site-content" id="deckSiteContent">

                    { !guest && leftNav !== false &&
                        <Layout.Sider width={ 320 } className={ sidebarClasses } theme='light' ref={ this.sidebarRef }>

                            <LeftNav
                                user={ user }
                                piersUser={ this.props.piersUser }
                                menu={ navigationData }
                                toggleSidebar={ this.toggleSidebar }
                                idUrl={ idUrl }
                                companyId={ currentCompany?.id }
                                contentLoaded={ contentLoaded } />
                        </Layout.Sider>
                    }
                    <Drawer open={ sidebarOpen } rootClassName='main-drawer' placement='left' width={ 10 } maskStyle={ { zIndex: 30, background: 'rgba(255,255,255,.7)' } } getContainer={ document.getElementById( 'deckSiteContent' ) } maskClosable={ false }>
                    </Drawer>
                    <div className="nkl-content-root">

                        { children }
                    </div>
                </div>
                { footer !== false &&
                    <Footer
                        companyId={ this.props.piersUser?.companies[ 0 ].id }
                        solutionId={ this.props.piersUser?.solutions[ 0 ].solutionId }
                        className={ footerClassName }
                    />
                }
            </Layout>
        );
    }
}
